var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105mm",
    height: "74mm",
    viewBox: "0 0 105 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m4254.98 585.059-105.18-.629c.59-66.621 11.04-171.871 14.2-232.93h53.6c8.42 49.09 22.77 125.98 37.38 233.559",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4164 351.5c.92-17.441 1.53-33.301 1.51-45.988h45.23c1.06 10.859 3.48 26.23 6.86 45.988H4164",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4024.94 585.059c14.59-107.579 28.97-184.469 37.38-233.559h53.6c3.16 61.059 10.45 166.309 11.03 232.93l-102.01.629",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4069.18 305.512h45.23c-.02 12.687.59 28.547 1.51 45.988h-53.6c3.38-19.758 5.81-35.129 6.86-45.988M4210.74 300c-.88-8.98-1.27-13.828-1.27-13.828h-44s0 5 .04 13.828h45.23",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4215.76 252.09h-55v36.012h55V252.09",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4161.97 297.891h52.6v7.621h-52.6v-7.621",
    style: {
      fill: "#208956",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4069.18 300c.88-8.98 1.27-13.828 1.27-13.828h44s0 5-.04 13.828h-45.23",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4064.16 252.09h55v36.012h-55V252.09",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4117.97 297.891h-52.62v7.621h52.62v-7.621",
    style: {
      fill: "#208956",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4053.18 688.949s-113.26-115.57-131.87-119.179c0 0 13.53-18.461 76.35-18.461 0 0 8.55-13.969 55.47-17.778 20.5-1.66 39.49-1.75 55.99 4.75 0 0 6.91-7.383 30.7-7.383v158.051h-86.64",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3997.66 551.309s46.21 30.453 55.52 52.66c0 0-63.1-59.321-131.87-34.199 0 0 16.72-19.149 76.35-18.461m111.46-13.028s11.47 42.168 7.91 54.77c0 0-10.08-51.641-28.93-59.731 0 0 11.67 1.25 21.02 4.961",
    style: {
      fill: "#208956",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4226.46 688.949s113.25-115.57 131.92-119.179c0 0-13.6-18.461-76.35-18.461 0 0-8.65-13.969-55.53-17.778-20.48-1.66-39.47-1.75-55.93 4.75 0 0-7.02-7.383-30.75-7.383v158.051h86.64",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4282.03 551.309s-46.25 30.453-55.57 52.66c0 0 63.09-59.321 131.92-34.199 0 0-16.74-19.149-76.35-18.461m-111.46-13.028s-11.47 42.168-7.89 54.77c0 0 10-51.641 28.8-59.731 0 0-11.62 1.25-20.91 4.961",
    style: {
      fill: "#208956",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4123.59 1082.64v-49.55H4166v49.55h-42.41",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4019.34 1045.76 11.03-112.561 114.24-16.289 130.21 94.61-130.02 21.98-70.23 5.52-55.23 6.74",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4188.32 1025.45 86.5-13.93-16.25-114.469-113.96 21.679.19 114.77 43.52-8.05",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4144.8 1033.5-42.98-55.059-27.25 60.579 32.71-6.74 37.52 1.22",
    style: {
      fill: "#208956",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4144.8 1033.5-40.42-42.559-29.81 48.079 48.79 2.05 21.44-7.57",
    style: {
      fill: "#d5f0e3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4144.8 1033.5 38.89-51.469 31.72 44.869-41.17 6.6h-29.44",
    style: {
      fill: "#208956",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4144.8 1033.5 40.49-42.559 30.12 35.959-49.59 14.17-21.02-7.57",
    style: {
      fill: "#d5f0e3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4030.37 940.57v-61.8c34.71-16.149 73.34-25.2 114.1-25.2 40.76 0 79.4 9.051 114.1 25.2v61.8h-228.2",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4258.57 692.23h-228.2v248.34h228.2V692.23",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4141.23 982.031c-1.07 0-1.93.918-2.01 1.949 0 1.122.88 2.02 2.01 2.02a1.93 1.93 0 0 0 1.97-1.922c0-1.129-.9-1.988-1.97-2.047zm-5.6 1.949c.05-4.859 4-8.761 8.8-8.8v17.812a8.901 8.901 0 0 1-8.8-9.012m12.65 2.051c1.07.039 1.97-.851 2.03-1.929 0-1.071-.9-1.993-1.99-1.993-1.07 0-2.01.84-2.01 1.969 0 1.102.9 1.953 1.97 1.953zm-3.85 6.961V975.18h.14c.04 0 .04-.059.1-.059 4.88.059 8.88 4.039 8.79 8.981 0 4.957-4.01 8.89-8.89 8.89h-.14",
    style: {
      fill: "#d5f0e3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4141.23 986c-1.13 0-2.01-.898-2.01-2.02.08-1.031.94-1.949 2.01-1.949 1.07.059 1.97.918 1.97 2.047a1.93 1.93 0 0 1-1.97 1.922m7.09-3.891c1.09 0 1.99.922 1.99 1.993-.06 1.078-.96 1.968-2.03 1.929-1.07 0-1.97-.851-1.97-1.953 0-1.129.94-1.969 2.01-1.969",
    style: {
      fill: "#208956",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4141.13 929.199c-1.13 0-1.97.922-2.01 1.949 0 1.102.88 2 1.97 2 1.08.051 1.98-.878 1.98-1.898 0-1.129-.9-2.051-1.94-2.051zm-5.64 1.949c0-4.839 4-8.828 8.89-8.847v17.84a8.969 8.969 0 0 1-8.89-8.993m12.69 2.051c1.1 0 1.98-.879 1.98-1.949 0-1.09-.88-1.988-1.92-1.988-1.13 0-2.03.898-2.03 1.988 0 1.07.9 1.949 1.97 1.949zm-3.8 6.942v-17.84h.05c.04 0 .04-.02.04-.02 4.98.039 8.93 4.051 8.89 8.969 0 4.922-4.04 8.93-8.93 8.891h-.05",
    style: {
      fill: "#d5f0e3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4141.09 933.148c-1.09 0-1.97-.898-1.97-2 .04-1.027.88-1.949 2.01-1.949 1.04 0 1.94.922 1.94 2.051 0 1.02-.9 1.949-1.98 1.898m7.15-3.886c1.04 0 1.92.898 1.92 1.988 0 1.07-.88 1.949-1.98 1.949-1.07 0-1.97-.879-1.97-1.949 0-1.09.9-1.988 2.03-1.988",
    style: {
      fill: "#208956",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4141.33 875.082c-1.13-.023-2.03.898-2.03 1.93 0 1.148.86 2.047 1.97 2.047 1.03.023 1.99-.879 1.99-1.93 0-1.129-.9-2.047-1.93-2.047zm-5.65 1.93c0-4.821 3.95-8.731 8.79-8.832v17.84c-4.88-.079-8.84-4.051-8.79-9.008",
    style: {
      fill: "#d5f0e3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4148.32 879.121c1.13 0 1.99-.941 2.03-1.973 0-1.078-.9-2.027-1.97-2.027-1.08 0-2.03.949-2.03 2.008 0 1.051.9 1.992 1.97 1.992zm-3.85 6.899v-17.84h.14c.06 0 .06-.02.06-.02 4.92.102 8.88 4.051 8.88 8.988 0 4.942-4.06 8.903-8.94 8.872h-.14",
    style: {
      fill: "#d5f0e3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4141.27 879.059c-1.11 0-1.97-.899-1.97-2.047 0-1.032.9-1.953 2.03-1.93 1.03 0 1.93.918 1.93 2.047 0 1.051-.96 1.953-1.99 1.93m7.11-3.938c1.07 0 1.97.949 1.97 2.027-.04 1.032-.9 1.973-2.03 1.973-1.07 0-1.97-.941-1.97-1.992 0-1.059.95-2.008 2.03-2.008",
    style: {
      fill: "#208956",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4044.9 1272.83c0-34.57-28.02-62.61-62.58-62.61-34.59 0-62.61 28.04-62.61 62.61s28.02 62.62 62.61 62.62c34.56 0 62.58-28.05 62.58-62.62",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4044.9 1363.5c0-34.55-28.02-62.6-62.58-62.6-34.59 0-62.61 28.05-62.61 62.6 0 34.6 28.02 62.61 62.61 62.61 34.56 0 62.58-28.01 62.58-62.61",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4103.24 1426.11c0-34.55-28.03-62.61-62.61-62.61-34.56 0-62.58 28.06-62.58 62.61 0 34.61 28.02 62.66 62.58 62.66 34.58 0 62.61-28.05 62.61-62.66",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4207.79 1450.94c0-34.57-28.01-62.58-62.61-62.58-34.55 0-62.62 28.01-62.62 62.58 0 34.59 28.07 62.61 62.62 62.61 34.6 0 62.61-28.02 62.61-62.61",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4223.93 1388.36c0-34.59-37.66-62.62-84.11-62.62-46.46 0-84.12 28.03-84.12 62.62 0 34.55 37.66 62.58 84.12 62.58 46.45 0 84.11-28.03 84.11-62.58",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4304.78 1426.11c0-34.55-28-62.61-62.61-62.61-34.57 0-62.62 28.06-62.62 62.61 0 34.61 28.05 62.66 62.62 62.66 34.61 0 62.61-28.05 62.61-62.66",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4367.4 1363.5c0-34.55-28.01-62.6-62.62-62.6-34.58 0-62.61 28.05-62.61 62.6 0 34.6 28.03 62.61 62.61 62.61 34.61 0 62.62-28.01 62.62-62.61",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4357.77 1282.54c0-34.61-28.02-62.62-62.57-62.62-34.6 0-62.62 28.01-62.62 62.62 0 34.57 28.02 62.62 62.62 62.62 34.55 0 62.57-28.05 62.57-62.62",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4295.2 1204.26c0-72.29-62.66-134.96-147.11-134.96-84.44 0-152.88 58.57-152.88 130.9 0 189.15 65.53 193.65 149.97 193.65 84.49 0 150.02-19.61 150.02-189.59",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4024.16 1169.73c0-11.55-9.36-20.92-20.92-20.92-11.56 0-20.92 9.37-20.92 20.92 0 11.56 9.36 20.95 20.92 20.95 11.56 0 20.92-9.39 20.92-20.95m247.85 0c0-11.55 9.42-20.92 20.94-20.92 11.56 0 20.96 9.37 20.96 20.92 0 11.56-9.4 20.95-20.96 20.95-11.52 0-20.94-9.39-20.94-20.95",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4110.63 1219.92c0-8.55-6.96-15.51-15.51-15.51-8.56 0-15.47 6.96-15.47 15.51 0 8.56 6.91 15.49 15.47 15.49 8.55 0 15.51-6.93 15.51-15.49",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4103.24 1223.63c0-3.55-2.91-6.44-6.44-6.44-3.52 0-6.39 2.89-6.39 6.44 0 3.54 2.87 6.43 6.39 6.43 3.53 0 6.44-2.89 6.44-6.43",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4175.45 1219.92c0-8.55 6.97-15.51 15.51-15.51 8.51 0 15.52 6.96 15.52 15.51 0 8.56-7.01 15.49-15.52 15.49-8.54 0-15.51-6.93-15.51-15.49",
    style: {
      fill: "#414042",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4182.83 1223.63c0-3.55 2.93-6.44 6.45-6.44 3.53 0 6.38 2.89 6.38 6.44 0 3.54-2.85 6.43-6.38 6.43-3.52 0-6.45-2.89-6.45-6.43",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4089.1 1269.84c-14.63 0-27.13-5.02-33.4-12.32 0 0 15.63 8.57 33.4 8.57 18.52 0 33.28-8.57 33.28-8.57-6.25 7.3-18.77 12.32-33.28 12.32m105.25 0c14.58 0 27.1-5.02 33.38-12.32 0 0-15.66 8.57-33.38 8.57-18.57 0-33.33-8.57-33.33-8.57 6.3 7.3 18.76 12.32 33.33 12.32",
    style: {
      fill: "#2f2927",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4145.18 1399.69c-82.8 0-149.97-33.95-149.97-75.74v-83.35c0 15.38 9.17 29.69 24.77 41.67 26.86 20.5 72.87 34.08 125.2 34.08 52.38 0 98.39-13.58 125.19-34.08 15.66-11.98 24.83-26.29 24.83-41.67v83.35c0 41.79-67.17 75.74-150.02 75.74",
    style: {
      fill: "#fbb040",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4145.18 1110.23c42.79 0 60.13 36.86 60.13 70.06H4085.1c0-33.2 19.18-70.06 60.08-70.06",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4317.58 711.742c2.15-7.133 32.11 2.598 31.81 10.039-2.71 70.989-18.3 197.188-18.3 197.188h-50.02s26.92-175.36 36.51-207.227",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4274.82 1011.52s57.84-29.411 57.52-106.911c0 0-23.06-12.308-47.87-12.308 0 0-16.66 13.008-17.85 22.738 0 0-45.57 27.832-10.29 73.242 7.93 10.25 18.49 23.239 18.49 23.239",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4672.4 268.789h60.04V662.77h-60.04V268.789m-916.35 0h-60.03V662.77h60.03V268.789",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4696.07 584.43h-978.69v114.3h978.69v-114.3",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4732.44 641.559H3696.02v81.961h1036.42v-81.961",
    style: {
      fill: "#9d7d61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3845.6 1330.04s19.93-6.09-14.7 53.67c-10.72 18.46-47.4-6.7-57.64-21.31 0 0 23.05-54.1 41.78-48.36l30.56 16",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3817.3 1373.91c2.52-3.99 1.86-8.89-1.44-10.94-3.36-2.21-8.05-.72-10.53 3.2l-38.32 61.08c-2.5 3.98-1.76 8.82 1.52 10.99 3.35 2.13 7.99.71 10.49-3.24l38.28-61.09m-13.65-14.32c2.48-4 1.84-8.89-1.5-11-3.32-2.18-8.01-.7-10.51 3.23l-38.28 61.11c-2.56 3.94-1.8 8.81 1.46 11 3.4 2.12 7.99.68 10.55-3.25l38.28-61.09",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3795.53 1340.16c2.54-3.95 30.97-24.4 27.65-26.57 0 0-3.98-5.33-12.71-6.03-7.5-.57-15.24 9.12-26.82 24.69-10.78 14.45-39.14 60.56-39.14 60.56-2.56 3.93-1.89 8.81 1.37 11.02 3.32 2.17 7.99.8 10.53-3.11l39.12-60.56m56.77 3.67c4.26-9.01-2.26-17.13-5.68-19.14l-19.35 13.24c-3.38-2.01.17 25.53-2.17 29.53l-36.49 62.23c-2.34 4.04-1.5 8.9 1.88 10.9 3.46 1.99 8.08.39 10.43-3.62 0 0 40-68.92 51.38-93.14",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3912.11 755.512H3715.1c-10.53 0-19.08-11.621-19.08-25.922v-18.418c0-14.32 8.55-25.922 19.08-25.922h197.01v70.262",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3912.11 744.75h-192.95c-8.48 0-15.29-8.129-15.29-18.129v-12.812c0-10.02 6.81-18.129 15.29-18.129h192.95v49.07",
    style: {
      fill: "#f9f7f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3949.18 836.871h-201.47c-10.8 0-19.53-11.582-19.53-25.891v-18.359c0-14.359 8.73-25.98 19.53-25.98h201.47v70.23",
    style: {
      fill: "#f15a29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3949.18 826.109h-197.33c-8.67 0-15.64-8.097-15.64-18.078V795.18c0-9.981 6.97-18.09 15.64-18.09h197.33v49.019",
    style: {
      fill: "#f9f7f7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3845.43 1334.69s-38.22-11.76-37.66-13.01c0 0 83.68-183.69 135.53-273.53 3.42-5.94 7.09-12.9 12.48-23.4l36.37 68.4c-50.9 81.83-146.72 241.54-146.72 241.54",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4036.37 1014.86s-16 33.69-27.21 51.23c-4.71 7.37-10.55 16.68-17.01 27.06l-36.37-68.4c11.5-22.5 37.21-73.93 79.32-153.969l1.27 144.079",
    style: {
      fill: "#2bb673",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4287.79 665.469h-295.9v46.953h295.9v-46.953",
    style: {
      fill: "#f9f9f9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4348.1 744.34s-67.67-20.36-121.83-37.289c0 0-22.74 1.929-37.79-1.821-14.87-3.691-29.5-26.011-18.58-24.64 33.48 4.14 48.67 3.058 48.67 3.058l132.46 8.692-2.93 52",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.05866 0 0 -.05866 -194.716 88.788)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent3);
export default __webpack_public_path__ + "static/media/student3.94d9abdb1af8388a04706ff86464b575.svg";
export { ForwardRef as ReactComponent };